import React from "react";
import { useState, useEffect, useFormContext, Hooks, Form, Field, Name, Title, Info, Code, Actions, Toast,  API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Orders } from "models/OrdersModel";
import { Item, emptyItem } from "models/ItemModel";
import { Inventory } from "models/InventoryModel";
import AsyncSelect from "react-select/async";
import { Calculate } from "helpers/CalculateHelpers"
import { HtmlDataFormat } from "components/common/HtmlFormat"
import { Extract } from "helpers/ExtractHelper";
import { ItemInventory } from "models/ItemInventoryModel";
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Product } from "models/ProductModel";

const OrdersForm: React.FC = () => {
  const width = { product: 46, status: 10, price: 10,  discount: 10, gst:10, amount: 10 }
  const [formId, formName] = [Code.Form.Id.ORDERS, Code.Form.Name.ORDERS];
  const {keyId, setKeyId, activeId, setActiveId, loading, setLoading, hasUnsaved, setHasUnsaved, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [doctorOptions, setDoctorOptions] = Hooks.Form.Options();
  const [insurerOptions, setInsurerOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Orders>({});
  const [initialData, setInitialData] = useState<Orders>({});
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const [itemInventoryData, setItemInventoryData] = useState<ItemInventory[]>([]); 
  const [segmentOptions, setSegmentOptions] = Hooks.Form.Options();
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const emptyOptions = Utility.Get.OptionValues([Code.Option.Common.NA]);
  const [selectedProduct, setSelectedProduct] = useState<OptionType | null>(null);
  const [localSkucode, setLocalSkucode] = useState<string>('');
  const [viewLabOrderButton, setViewLabOrderButton] = useState<boolean>(false);
  
  const [orderStatusId, setOrderStatusId] = useState<number>(0);
  const [orderStatusName, setOrderStatusName] = useState<string>('');

  const [localStatusId, setLocalStatusId] = useState<Number>(0);
  
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  const companyId = Utility.Storage.CompanyId();
  const userId = Utility.Storage.UserId();
  
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  const RoleSpecial = Hooks.Privilege.RoleSpecial();
  Hooks.Privilege.HasOpen(Privilege);
   
  useEffect(() => {
   Files.Json.API(Code.File.DOCTOR, Code.Option.Common.NA, setDoctorOptions, setError);
    Files.Json.API(Code.File.INSURER, Code.Option.Common.NA, setInsurerOptions, setError);
    Files.Json.API(Code.File.SEGMENT, Code.Option.Common.SELECT, setSegmentOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.ORDER_STATUS, Code.Option.Common.NA, setStatusOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.ORDER_TYPE, Code.Option.Common.NA, setTypeOptions, setError);
    Files.Json.API(Code.File.USER, Code.Option.Common.SELECT, setUserOptions, setError);
    
    API.Data.GetByKeyId<Orders>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.orders_active); 
        const clientData = await API.Data.getClientNameNumber(data.client_id);
        const formData = await Form.Map.Data(data);
        const finalData = {
          ...formData,
          ...clientData, 
        };
        setFormData(finalData);
        setInitialData(finalData);
        setLocalStatusId(data.status_id || 0);
        Utility.Storage.Set(Code.Form.Name.ORDERS,data.orders_id);
        callItemList(data.orders_id);
        //console.log("orders data------>",formData);
        setLoading(false);
      }})

    const onNewEntry = async () => {
      if(keyId===Code.Key.NEW) {
        if(clientId){
          const clientName = await API.Data.GetClientName(Number(clientId));
          const newData = {
            client_id: Number(clientId),
            client_name: Utility.Value.Text(clientName),
          };
          setFormData(newData);
        }
        setFormData((prev) => ({
          ...prev, 
          segment_id: Code.Option.Segment.OPTICAL,
          user_id: userId,
        }));
        setInitialData(formData);
      }
      setLoading(false);
    };
    onNewEntry();
    
  }, []);

  useEffect(() => { 
    const hasChanged = JSON.stringify(formData) !== JSON.stringify(initialData);
    setHasUnsaved(hasChanged); 
  }, [formData, initialData]);

  const callItemList = async (ordersId: number | undefined) => {
    if (!ordersId) return;  
      const url = API.Build.FormApiEndpint(Code.Form.Name.ITEM, 200, Name.Item.Id, Code.Option.Sort.ASC, {
      fields: Utility.Join.Fields([
        Name.Item.All, 
        Name.Product.Name, 
        Name.Item.UTN,
        Name.Item.SKU,
        Name.Item.ItemStatusName,
        Name.Item.OrderStatusName,
        Name.Inventory.Data,
        Name.Specification.Id,
      ]),
      [Name.Common.FormId]: Code.Form.Id.ORDERS,
      [Name.Common.CommonId]: ordersId,
    });
    //console.log("Item List URL----------->:",url);
    await API.Data.List<ItemInventory>(url, setItemInventoryData, setError, setLoading);
  };

  useEffect(()=>{
    //console.log("itemInventoryData------>",itemInventoryData);
    setFormData((prevData) => {
      const grandTotals = Calculate.SubTotals(itemInventoryData,formName);
       return {
        ...prevData,
        orders_gross_amount: grandTotals.orders_gross_amount || 0,
        orders_discount_amount: grandTotals.orders_discount_amount || 0,
        orders_deposit_amount: grandTotals.orders_deposit_amount || 0,
        orders_taxable_amount: grandTotals.orders_taxable_amount || 0,
        orders_tax1_amount: grandTotals.orders_tax1_amount || 0,
        orders_net_amount: grandTotals.orders_net_amount || 0,
        orders_payable_amount: grandTotals.orders_payable_amount || 0,
      };
    });

    if (itemInventoryData.length >= 3) {
      const hasFrame = itemInventoryData.some(item => item.specification_id === Number(Code.Option.Control.FRAME));
      const hasLens = itemInventoryData.some(item => item.specification_id === Number(Code.Option.Control.LENS));
      const hasExam = itemInventoryData.some(item => item.specification_id === Number(Code.Option.Control.EXAM));
      
      if (hasFrame && hasLens && hasExam) {
        setViewLabOrderButton(true);
      }
    }


  },[itemInventoryData])

  useEffect(()=>{
      //console.log("Status ID changed new:", orderStatusId);
      //console.log("Status name changed :", orderStatusName);
      //console.log("Status ID changed old:", localStatusId);
      setOrderStatusId(formData.status_id || 0);
  },[formData.status_id])

  const addItem = async () => {

    if(!formData) {
      Utility.Message.Warning(["No order found"],setMessage);
      return;
    }

    //console.log("----->",localSkucode,selectedProduct?.value);
    
    if (!localSkucode && selectedProduct == null) {
      Utility.Message.Warning(["Select Product or SKU/UTN Number"],setMessage);
      return;
    }
      

    const company_id = Utility.Storage.CompanyId();
    const location_id = Utility.Storage.LocationId();
    const user_id = Utility.Storage.UserId();
    const orders_id = formData.orders_id;
    const client_id = formData.client_id;
    const baseData = { company_id, location_id, user_id, client_id };
    let salePrice = 0;

    if(localSkucode)
    {
      //when project selected from list
      let productId = 2
      let productName = ''
      let specificationId = 2;
      let productComment = '';
      let utnCode = ''
      let skuCode = ''
      let inventoryId = 2;
      let salePrice = 0;
      let quantity = 1;
      let discountPercent = 0;
      let discountAmount = 0;
      let taxPercent = 0;
      
      const fields = Utility.Join.Fields([
        Name.Inventory.SKU,
        Name.Inventory.UTN,
        Name.Inventory.SerialNo,
        Name.Inventory.Sale,
        Name.Product.Id,
      ]);

      const inventoryData = await API.Data.GetInventoryViewById<Inventory>(localSkucode);
      if(inventoryData){
        utnCode = inventoryData.inventory_utncode || '';
        skuCode = inventoryData.inventory_skucode || '';
        specificationId = inventoryData.specification_id || 2;
        productId = inventoryData.product_id || productId;
        inventoryId = inventoryData.inventory_id || inventoryId;
        salePrice = inventoryData.inventory_sale_price || 0;
        productComment = Utility.Get.ProductSummary(inventoryData, specificationId);
        productName = inventoryData.product_name || productName;
        salePrice = inventoryData.product_sale_price || 0;
        discountPercent = inventoryData.offer_percentage || 0;
        discountAmount = inventoryData.offer_amount || 0;
        taxPercent = inventoryData.tax_percentage || 0;
      }
      else { Utility.Message.Warning(["No inventory found for the entered SKU/UTN"],setMessage); return; }

      // const inventoryData = await API.Data.GetInventoryBySearch(Name.Inventory.SKU, localSkucode, fields);
      // if(inventoryData){
      //     //console.log("inventoryData------>",inventoryData);
      //     utnCode = inventoryData.inventory_utncode || '';
      //     skuCode = inventoryData.inventory_skucode || '';
      //     productId = inventoryData.product_id || 2;
      //     inventoryId = inventoryData.inventory_id || inventoryId;
      //     salePrice = inventoryData.inventory_sale_price || 0;

      //     const productData = await API.Data.GetProduct(productId);
      //     if(productData){
      //         //console.log("productData------>",productData);
      //         productName = productData.product_name || '';
      //     }
      // }

      const finalItem: Item = { 
        ...emptyItem, 
        ...baseData,
        item_date: Utility.Get.CurrentDateTime(),
        form_id: Code.Form.Id.ORDERS,
        common_id: formData.orders_id,
        stock_status_id: 1,
        item_utncode: utnCode,
        item_skucode: skuCode,
        inventory_id: inventoryId,
        item_price: Number(salePrice),
        item_quantity: quantity,
        item_gross_amount: Number(salePrice * quantity),
        item_net_amount: Number(salePrice * quantity),
        ...(productId !== 0 && {
          product_id: productId,
        }),
      };

      const response = await API.Data.Save(Code.Form.Name.ITEM, Code.Key.NEW, finalItem, setMessage, true, Code.Form.PopupClose.REMAINOPEN)
      if(response){
        onRefresh();
        Utility.Message.Info(["Product added successfully"],setMessage);
        setSelectedProduct({value: 0, label: 'Select'});
        setLocalSkucode('');
      }
    } 
    else 
    {
      let productId = selectedProduct?.value || 0;
      let productName = selectedProduct?.label || '';
      let productComment = '';
      let salePrice = 0;
      let grossPrice = 0;
      let discountPercent = 0;
      let discountAmount = 0;
      let taxableAmount = 0;
      let taxPercent = 0;
      let taxAmount = 0;
      let netAmount = 0;
      let quantity = 1;

      const productData = await API.Data.GetProductViewById<Product>(productId);
      if(productData){
        productName = productData.product_name || productName;
        productComment = productData.product_comment || '';
        salePrice = productData.product_sale_price || 0;
        discountPercent = productData.offer_percentage || 0;
        discountAmount = productData.offer_amount || 0;
        taxPercent = productData.tax_percentage || 0;
        quantity = productData.product_min_sale || 1;
      }
      else{ Utility.Message.Warning(["Product not found"],setMessage); return; }

      // const [productData, offerData, taxData] = await API.Data.GetProductOfferTax(productId);
      // if(productData){
      //   salePrice = productData.product_sale_price || 0;
      // }
      grossPrice = salePrice * quantity;

      if(discountPercent>0){
        discountAmount = (grossPrice * discountPercent) / 100;
      }

      taxableAmount = grossPrice - discountAmount;
      
      if(taxPercent>0){
        taxAmount = (taxableAmount * taxPercent) / 100;
      }

      netAmount = taxableAmount + taxAmount;

      const itemData: Item = {
        ...baseData,
        form_id: Code.Form.Id.ORDERS,
        common_id: orders_id,
        item_skucode: localSkucode,
        product_id: productId,
        item_price: Number(salePrice),
        item_quantity: quantity,
        item_gross_amount: Number(grossPrice),
        item_discount_percentage: Number(discountPercent),
        item_discount_amount: Number(discountAmount),
        item_taxable_amount: Number(taxableAmount),
        item_tax1_percentage: Number(taxPercent),
        item_tax1_amount: Number(taxAmount),
        item_net_amount: Number(netAmount),
      };
    
      const inventoryData: Inventory = {
        ...baseData,
        product_id: productId,
        inventory_skucode: localSkucode,
      };
    
      const response = await API.Data.SaveItemInventory(Code.Key.NEW, Code.Key.NEW, itemData, inventoryData, Code.Form.PopupClose.REMAINOPEN);
      if(response){
        onRefresh();
        Utility.Message.Info(["Product added successfully"],setMessage);
        setSelectedProduct({value: 0, label: 'Select'});
        setLocalSkucode('');
      }
    }

   
  };

  const calculateFunction = (updatedFormData: any) => {
    let roundOffAmount = Number(updatedFormData.orders_roundoff_amount) || 0;
    let netAmount = Number(updatedFormData.orders_net_amount) || 0;
    let payableAmount = Number(updatedFormData.orders_payable_amount) || 0;
    let insurer1Amount = Number(updatedFormData.orders_insurer1_amount) || 0;
    let insurer2Amount = Number(updatedFormData.orders_insurer2_amount) || 0;

    payableAmount = netAmount + roundOffAmount;
    let clientAmount = payableAmount - (insurer1Amount + insurer2Amount);

    return {
      ...updatedFormData,
      orders_payable_amount: Utility.Maths.toDecimal(payableAmount),
      orders_client_amount: Utility.Maths.toDecimal(clientAmount),
    };
  };

  // Recalculate when any dependent value changes
  useEffect(() => {
    setFormData((prev) => calculateFunction(prev));
  }, [ formData.orders_net_amount, formData.orders_roundoff_amount, formData.orders_net_amount ]);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;

    let statusChangeHistory= '';
    if(localStatusId && localStatusId != formData.status_id){
      let userName = Utility.Storage.UserName();
      let userId = Utility.Storage.UserId();

      if(formData.status_id == 571){
        //30 - Anchal Singh, 21 - Ramandeep Kaur, 7 - Sanjeev
        if(userId==30 || userId==21 || userId==7) userName = "Kuldip Parmar";
      }
      
      const now = Utility.Format.DateNow();
      const formattedDate = Utility.Format.Date(now,"yyyy-MM-dd hh:mm tt");
      statusChangeHistory = `${orderStatusName} on ${formattedDate} by ${userName}; `;  
      let history =  formData.orders_status_history;
      history =  history ? history : '';
      formData.orders_status_history = history += statusChangeHistory;
    }

    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
    });

    const response = await API.Data.Save(formName, keyId, finalData, setMessage,true, Code.Form.PopupClose.REMAINOPEN);
    if(response){
      //Utility.Set.NewlyCreatedId(response,keyId,formName,setKeyId,setActiveId,setFormData);
      //const newId = Extract.Key.Decode(keyId);
      //Utility.Storage.Set(Code.Form.Name.ORDERS,newId);
      
      //re-usable control added above for this code
      if(keyId===Code.Key.NEW){
        const localKeyId= response.data[Code.Key.NEWID];
        const localNewId= Extract.Key.Decode(localKeyId);
        setKeyId(localKeyId);
        setActiveId(Code.Option.Active.ACTIVE);
        Utility.Storage.Set(Code.Form.Name.ORDERS,localNewId);
        setFormData((prev) => ({
          ...prev,
          orders_id: localNewId,
          orders_key: localKeyId,
        }));
      }

      setInitialData(formData);
      setHasUnsaved(false);
    }
  };

  const onRefresh = () => {
    const OrdersId = Utility.Storage.Get(Code.Form.Name.ORDERS);
    if(OrdersId){
      callItemList(Number(OrdersId));
    }
  };

  const sendPickupMessage = async () => {
    try {
      const clientId = formData.client_id || 0;
      const locationId = formData.location_id || 0; 
      const segmentId = Number(Code.Option.MessageSegment.PICKUP); 
    
      //console.log("Sending Pickup Message with Client ID:", clientId, "Location ID:", locationId, "Segment ID:", segmentId);

      if(clientId>0 && locationId>0 && segmentId>0) {  
        const response = await API.Data.sendMessage(formData.client_id, formData.location_id, Code.Option.MessageSegment.PICKUP, setMessage );
        //console.log(response);
      }
      
    } catch (error) {
      console.error(error);
    }
  };

 
  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} hasUnsaved={hasUnsaved} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} print={true} >
            {keyId !== Code.Key.NEW && (
              <Control.Form.CheckList title='Options' width={180}>
                {
                  (companyId == 10 || companyId == 15) ? 
                    <Button.Action title={'Lab Order 1'} info={Info.AddProduct} onClick={() => viewLabOrderButton ?  navigate(`/laborder1/print/${keyId}`) : Utility.Message.Error([`To view the lab order, all three are required: frame, lens, and prescription.`], setMessage) } />
                  : <Button.Action title={'Lab Order 2'} info={Info.AddProduct} onClick={() => viewLabOrderButton ?  navigate(`/laborder2/print/${keyId}`) : Utility.Message.Error([`To view the lab order, all three are required: frame, lens, and prescription.`], setMessage) } />
                }
                {companyId === 10 && orderStatusId == 571 && <Button.Action title={'Send Pickup SMS'} info={"Click here to send pickup message"} onClick={sendPickupMessage} animation={false} />}
              </Control.Form.CheckList>
            )}
          </Button.Save>
          <Control.Tab.Header titles={["Details", "More"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Date id={Name.Orders.Date} value={formData.orders_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,20,1]} currentDate={true} />
                <Field.FilterSelect id={Name.Common.SegmentId} value={formData.segment_id} title={Title.Segment} options={segmentOptions} setFormData={setFormData} require={true} size={[1,20,1]} defaultValue={Code.Option.Segment.OPTICAL} />
                <Field.FilterSelect id={Name.Common.TypeId} value={formData.type_id} title={Title.Type} options={typeOptions} setFormData={setFormData} size={[1,20,1]}  />
                <Field.FilterSelect id={Name.Common.StatusId} value={formData.status_id} title={Title.Status} options={statusOptions} setFormData={setFormData} size={[1,20,1]} setSelectedName={setOrderStatusName} />
                <Field.FilterSelect id={Name.User.Id} value={formData.user_id} title={Title.Dispenser} options={userOptions} setFormData={setFormData} size={[1,20,0]} require={true} disabled={!RoleSpecial.includes(Code.RoleSpecial.ENABLE_DISPENSER_NAME)} />
              </Control.Row>
              <Control.Row>
                <Field.Header id={Name.Client.Id} title={Title.Client} require={true}>
                  <AsyncSelect id={Name.Client.Id} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.CLIENT, Code.Mapping.client.value, Code.Mapping.client.label)} styles={Code.Style.FormOption} onChange={(selected) => Utility.Handle.ClientChange(selected, setFormData)} value={Utility.Value.Async(formData.client_id,formData.client_name)} placeholder="Search" />
                </Field.Header>
              </Control.Row>
              <Control.Row>
                <Field.Header id={Name.Product.Id} title={Title.Product} size={[0,50,1]}>
                  <AsyncSelect id={Name.Product.Id} value={selectedProduct} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.PRODUCT, Code.Mapping.product.value, Code.Mapping.product.label)} styles={Code.Style.FormOption} onChange={(selected) => setSelectedProduct(selected as OptionType | null)} placeholder="Search" />
                </Field.Header>
                <Field.Text id={Name.Item.SKU} value={localSkucode} title={Title.Skucode} onChange={(e) => setLocalSkucode(e.target.value)} size={[1,20,1]} />
                <Button.FrameAction title="+" info={Info.AddProduct} infoDisable={Info.DisableAddProduct} onClick={addItem} size={[1,20,1]} className='pt6' disable={keyId===Code.Key.NEW ? true : false} />
              </Control.Row>
              <Control.Form.Table>
                <Control.Form.Title>
                  <Control.Grid.Items values={[
                    ["Product/Specifications", width.product], 
                    [Title.State, width.status], 
                    ['Price/Qty.', width.price, Code.Align.RIGHT], 
                    [Title.Discount, width.discount, Code.Align.RIGHT],
                    [Title.GST, width.gst, Code.Align.RIGHT],
                    [Title.Amount, width.amount, Code.Align.RIGHT]
                  ]} first={1} />
                </Control.Form.Title>
                <Control.Form.List>
                  {itemInventoryData?.map((item, index) => (
                    <Control.Form.Index key={index} index={index}>
                      <Control.Form.OrderTextArea 
                        path={`${Utility.Join.Edit(Privilege, Code.Form.Name.ORDERS, Code.Form.Name.ITEM, item.item_key)}?${Code.UrlPara.Client}=${formData.client_id}`} 
                        iframeRef={iframeRef} 
                        index={index} 
                        specification={item.specification_id}
                        data={HtmlDataFormat(item.specification_id, item.inventory_data)}
                        productName={item.product_name} 
                        utncode={item.item_utncode} 
                        skucode={item.item_skucode} 
                        frameStatus={Utility.Remove.NA(item.item_status_name)}
                        orderStatus={Utility.Remove.NA(item.order_status_name)}
                        price={item.item_price}
                        quantity={item.item_quantity}
                        discAmount={item.item_discount_amount}
                        discPercentage={item.item_discount_percentage}
                        tax1Amount={item.item_tax1_amount}
                        tax1Percentage={item.item_tax1_percentage}
                        netAmount={item.item_net_amount}
                      />
                    </Control.Form.Index>
                  ))}
                </Control.Form.List>
              </Control.Form.Table>
              <Control.Flex>
                <Control.Column size={[0,35,0,2]}>
                  <Control.Row>
                    <Field.Text value="Client" title="Payable by" size={[0,50,1]} disabled={true} />
                    <Field.Amount id={Name.Orders.ClientAmount} value={formData.orders_client_amount}  title="Amount" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} disabled={true} />
                  </Control.Row>
                  <Control.Row>
                    <Field.FilterSelect id={Name.Common.insurer1Id} value={formData.insurer1_id} options={insurerOptions} setFormData={setFormData} size={[0,50,1]} />
                    <Field.Amount id={Name.Orders.Insurer1Amount} value={formData.orders_insurer1_amount} onChange={(e) => Utility.Handle.Calculate(e, setFormData, calculateFunction)} size={[1,50,0]} />
                  </Control.Row>
                  <Control.Row>
                    <Field.FilterSelect id={Name.Common.insurer2Id} value={formData.insurer2_id} options={insurerOptions} setFormData={setFormData} size={[0,50,1]} />
                    <Field.Amount id={Name.Orders.Insurer2Amount} value={formData.orders_insurer2_amount} onChange={(e) => Utility.Handle.Calculate(e, setFormData, calculateFunction)} size={[1,50,0]} />
                  </Control.Row>
                </Control.Column>
                <Control.Column size={[0,15,0,3]}><></></Control.Column>
                <Control.Column size={[0,50,0,1]}>
                  <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    <Field.Amount id={Name.Orders.Gross} value={formData.orders_gross_amount} title={Title.Gross} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]} />
                    <Field.Amount id={Name.Orders.Discount} value={formData.orders_discount_amount} title={Title.Discount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]}  />
                    {/* <Field.Number id={Name.Order.DepositAmount} value={formData.orders_deposit_amount} title={Title.Deposit} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,16,0]} /> */}
                  </Control.Row>
                  <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    {/* <Field.Number id={Name.Order.TaxableAmount} value={formData.orders_taxable_amount} title={Title.Taxable} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,16,1]} /> */}
                    <Field.Amount id={Name.Orders.Tax1} value={formData.orders_tax1_amount} title={Title.Tax} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]}  />
                    <Field.Amount id={Name.Orders.Net} value={formData.orders_net_amount} title={Title.NetAmount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]}  />
                  </Control.Row>
                  <Control.Row>
                    <Field.Title size={[0,32,1]} />
                    <Field.Amount id={Name.Orders.Roundoff} value={formData.orders_roundoff_amount} title={Title.Roundoff} onChange={(e) => Utility.Handle.Calculate(e, setFormData, calculateFunction)} size={[1,34,1]} />
                    <Field.Amount id={Name.Orders.Payable} value={formData.orders_payable_amount} title={Title.Payable} onChange={(e) => Utility.Handle.Calculate(e, setFormData, calculateFunction)} size={[1,34,0]}  />
                  </Control.Row>
                  {/* <Control.ButtonColumn size={[40,4,0,0,0]} align={Code.Align.RIGHT}>
                    <Button.Action title={'Generate Release'} info={Info.AddProduct} onClick={generateRelease} />
                    <Button.Action title={'Send msg'} info={Info.AddProduct} onClick={sendMessage} />
                  </Control.ButtonColumn> */}
                </Control.Column>
              </Control.Flex>
            </Control.Tab.Content>
            
            <Control.Tab.Content id={Code.Tab.Tab2} isActive={activeTab === Code.Tab.Tab2}>
              <Control.Flex>
                <Control.Column size={[0,50,2,1]}>
                  <Control.Row>
                    <Field.FilterSelect id={Name.Doctor.Id} value={formData.doctor_id} title={Title.Doctor} options={doctorOptions} setFormData={setFormData} size={[0,50,1]} />
                    <Field.Text id={Name.Orders.Number} value={formData.orders_number} title={Title.SNo} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} disabled={true} />
                  </Control.Row>
                  <Control.Row>
                    <Field.FilterSelect id={Name.Common.TermId} value={formData.term_id} title={"Terms & Conditions"} options={emptyOptions} setFormData={setFormData} size={[0,50,1]} />
                    <Field.Text id={Name.Orders.RefNo} value={formData.orders_ref_number} title={'Tray/Ref. Number'} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
                  </Control.Row>
                  <Control.Row>
                    <Field.Area id={Name.Orders.Comment} value={formData.orders_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} height={160}  />
                  </Control.Row>
                  <Control.Row>
                      <Field.FilterSelect id={Name.Address.Id} value={formData.address_id} title={"Delivery Address"} options={emptyOptions} setFormData={setFormData} size={[0,50,1]}  />
                  </Control.Row>
                </Control.Column>
                <Control.Column size={[2,50,0,2]}>
                  <Field.Area id={Name.Orders.StatusHistory} value={formData.orders_status_history} title={"Status Chage History"} onChange={(e) => Form.Field.Change(e, formData, setFormData)} height={300} />
                </Control.Column>
              </Control.Flex>
            </Control.Tab.Content>
          
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} print={true} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={onRefresh} />
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default OrdersForm;